import Spacer from "components/Spacer";
import type { SpacerProps } from "components/Spacer";

interface HeadingAdapterProps {
  blok: SpacerProps;
}

const SpacerAdapter = ({ blok: { hDesktop, hMobile } }: HeadingAdapterProps) => (
  <Spacer hDesktop={hDesktop} hMobile={hMobile} />
);

export default SpacerAdapter;
